<template>
  <DefaultPage>
    <section class="section" id="together">
        <div class="panel" data-aos="fade"
                           data-aos-duration="1000">
          <div class="panel__item">
            <div class="panel__item__icon panel__item__icon--relief">
                 <img src="../assets/relief-dude.png" alt="" class="person">
                 <img src="../assets/relief-bg-shape.png" alt="" class="bg">
                 <img src="../assets/relief-desk.png" alt="" class="setting">
            </div>
            <div class="panel__item__content"
               data-aos="fade-up">
              <div class="panel__item__content__header">
                <h3 class="panel__item__content__header__title">Getting Through 2020 Together</h3>
                <h5 class="panel__item__content__header__subtext">Protecting and Supporting our Members</h5>
              </div>
              <div class="panel__item__content__text">
                <p>We strive to match the commitment and dedication that our members have for their patients, profession, and communities. As a mutual company, we’ve been able to help our doctors continue practicing and assisting on the front lines by suspending premium rate increases, implementing temporary reductions in premiums for practices directly affected by the pandemic, and providing more flexible payment options where needed.</p>
              </div>
            </div>
          </div>
        </div>
    </section>
    <section class="section" id="shoulder">
        <div class="panel" data-aos="fade"
                           data-aos-duration="1000">
          <div class="panel__item panel__item--reverse">
            <div class="panel__item__icon panel__item__icon--tools">
                 <img src="../assets/tools-doc.png" alt="" class="person">
                 <img src="../assets/tools-bg.png" alt="" class="bg">
                 <img src="../assets/tools-phone.png" alt="" class="setting">
            </div>
            <div class="panel__item__content"
               data-aos="fade-up">
              <div class="panel__item__content__header">
                <h3 class="panel__item__content__header__title">With You Shoulder to Shoulder</h3>
                <h5 class="panel__item__content__header__subtext">Responsive Education, Resources, and Consulting</h5>
              </div>
              <div class="panel__item__content__text">
                <p>All of our teams rolled up their sleeves and provided new specialized resources and access that practices needed in order to stay up-to-date and equipped to practice medicine in an even more ever-changing environment. Some of this year's unique steps included waiving all fees for our education courses, a new Discussions area in Vantage® for practice managers to share information and ideas, providing round-the-clock access to our consultants, and enhanced access to online resources.</p>
              </div>
            </div>
          </div>
        </div>
    </section>
    <section class="section" id="focus">
        <div class="panel" data-aos="fade"
                           data-aos-duration="1000">
          <div class="panel__item">
            <div class="panel__item__icon panel__item__icon--focus">
                 <img src="../assets/focus-practice-manager.png" alt="" class="person">
                 <img src="../assets/focus-bg.png" alt="" class="bg">
                 <img src="../assets/focus-profiles.png" alt="" class="setting">
            </div>
            <div class="panel__item__content"
               data-aos="fade-up">
              <div class="panel__item__content__header">
                <h3 class="panel__item__content__header__title">focused on the future</h3>
                <h5 class="panel__item__content__header__subtext">Leaning on Technology to Keep Us Connected</h5>
              </div>
              <div class="panel__item__content__text">
                <p>With social distancing, we provided innovative ways to keep close with our members. We have recorded our annual education seminars and are using our existing digital platforms to send them out with our other resources. We also created Forum. Forum is a virtual place where the younger generation of practicing medical professionals frequently meet to help us stay in touch with what’s important to physicians, which drives the development of new initiatives and resources for our members. With their insight into the unique issues doctors are facing, we have adjusted our support and services to better serve our current and future policyholders.</p>
              </div>
            </div>
          </div>
        </div>
    </section>
  </DefaultPage>
</template>

<script>
import DefaultPage from '@/layouts/DefaultPage';

export default {
  name: 'Focus',
  components: { DefaultPage },
  mounted () {
    $(window).scroll(function () {
      var scrollPos = $(window).scrollTop();
      if ($(window).width() > 1024) {
        $('.panel__item__icon .person').css({
          transform: 'translateY(-' + scrollPos / 30 + 'px)'
        });
        $('.panel__item__icon .setting').css({
          transform: 'translateX(' + scrollPos / 40 + 'px)'
        });
        $('.panel__item__icon--tools .setting').css({
          transform: 'translateX(-' + scrollPos / 40 + 'px)'
        });
      }
    });
    $(window).resize(function () {
      if ($(window).width() < 1024) {
        $('.panel__item__icon .person').css({
          transform: 'translateY(0)'
        });
        $('.panel__item__icon .setting').css({
          transform: 'translateX(0)'
        });
        $('.panel__item__icon--tools .setting').css({
          transform: 'translateX(0)'
        });
      }
    });
  }
};
</script>
